import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { setFormFieldValue, validateFormField } from '../../../reducers/formReducer'

export class TextField extends Component {
  constructor(props) {
    super(props)
    this.valueChange = this.valueChange.bind(this)
  }

  componentDidMount() {
    const { formType, fieldName, defaultValue } = this.props
    const initialValue = defaultValue || ''
    if (typeof formType !== 'undefined') {
      this.props.setFormFieldValue(formType, fieldName, initialValue)
      this.props.validateFormField(formType, fieldName, this.isValid(initialValue))
    }
  }

  componentWillReceiveProps(nextProps) {
    const { formType, fieldName, defaultValue } = this.props
    if (typeof formType !== 'undefined' && defaultValue !== nextProps.defaultValue) {
      this.props.setFormFieldValue(formType, fieldName, nextProps.defaultValue)
      this.props.validateFormField(formType, fieldName, this.isValid(nextProps.defaultValue))
    }
  }

  valueChange(e) {
    e.preventDefault()
    const { formType, fieldName, onChange } = this.props
    if (typeof formType !== 'undefined') {
      this.props.setFormFieldValue(formType, fieldName, e.target.value)
      this.props.validateFormField(formType, fieldName, this.isValid(e.target.value))
    }
    if (typeof onChange === 'function') {
      onChange(e)
    }
  }

  isValid(val) {
    return val.toString().length > 0
  }

  render() {
    const {
      form,
      formType,
      fieldName,
      label,
      placeholder,
      additionalClass,
      isDisabled,
      fieldType,
      value,
      min,
    } = this.props
    return (
      <div className="field">
        {label && (
          <label htmlFor={fieldName} className="label">
            {label}
          </label>
        )}
        <div className="control">
          <input
            className={`input ${additionalClass || ''}`}
            value={typeof formType !== 'undefined' ? form[formType][fieldName].value : value}
            onChange={this.valueChange}
            name={fieldName}
            id={fieldName}
            disabled={isDisabled}
            placeholder={placeholder}
            type={fieldType}
            min={min}
          />
        </div>
      </div>
    )
  }
}

TextField.propTypes = {
  form: PropTypes.object,
  formType: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  additionalClass: PropTypes.string,
  setFormFieldValue: PropTypes.func,
  validateFormField: PropTypes.func,
  isDisabled: PropTypes.bool.isRequired,
  fieldType: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  min: PropTypes.number,
}

TextField.defaultValue = {
  fieldType: 'text',
}

export default connect(
  (state) => {
    return {
      form: state.form,
    }
  },
  { setFormFieldValue, validateFormField },
)(TextField)
